import { CaretLeftOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Colors } from '../../helpers/Colors'
const GoBack = ({ path, mt = '10px', state = {} }) => {
    const history = useHistory()
    const onClick = () => history.push({ pathname: path, state: state })
    return (
        <Button onClick={onClick} style={{ background: 'white', color: Colors.mainBlue, borderRadius: '10px', fontWeight: "800", marginTop: mt }}> <CaretLeftOutlined />Back</Button>
    )
}

export default GoBack